import { createSelector } from 'reselect';

const selectGlobals = (state) => state.globals;

export const selectGlobalsSettings = createSelector([selectGlobals], (globals) => globals.settings);

export const selectIsLoading = createSelector([selectGlobals], (globals) => globals.isLoading);

export const selectNavigation = createSelector([selectGlobals], (globals) => globals.settings.navigation.primaryNavigation);

export const globalError = createSelector([selectGlobals], (globals) => globals.globalError);

export const selectPageData = createSelector([selectGlobals], (globals) => globals.pageData);

export const selectDictionary = createSelector([selectGlobals], (globals) => globals.settings.dictionary);

export const selectLocations = createSelector([selectGlobals], (globals) => globals.settings.locations);

export const selectLanguages = createSelector([selectGlobals], (globals) => globals.settings.languages);

export const selectUser = createSelector([selectGlobals], (globals) => globals.user);

export const selectCookieSettings = createSelector([selectGlobals], (globals) => globals.cookieSettings);

export const selectCanScroll = createSelector([selectGlobals], (globals) => globals.canScroll);
